import React from "react";

const ExcellenceIcon = () => {
   return (
      <svg
         id="Layer_1"
         data-name="Layer 1"
         xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 138 121.11"
      >
         <defs>
            <style>.cls-1fill:#494948;</style>
         </defs>
         <path
            className="cls-1"
            d="M6,82.65a3.26,3.26,0,0,1,3.14-1.57c3.45.06,6.9,0,10.35,0,1.81,0,2.93,1.31,2.53,2.82a2.09,2.09,0,0,1-2.09,1.75c-3.9,0-7.8,0-11.69,0-1.08,0-1.62-.77-2.24-1.44Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M144,84.27a3.4,3.4,0,0,1-3.18,1.47c-3.36-.08-6.72,0-10.08,0-1.8,0-2.87-.89-2.85-2.31s1.1-2.29,2.89-2.3c3.36,0,6.72,0,10.08,0A3.27,3.27,0,0,1,144,82.65Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M33.59,83.32A41.41,41.41,0,1,1,74.7,124.79,41.53,41.53,0,0,1,33.59,83.32Zm19.25,27.33c-.05,2.24,1.72,3.24,3.66,2.22,5.82-3.07,11.63-6.15,17.42-9.29a2,2,0,0,1,2.2,0c5.67,3.06,11.37,6.07,17,9.12,1,.53,2,.92,3,.19s1.07-1.88.87-3C96,103.44,94.9,97,93.74,90.54a2.07,2.07,0,0,1,.71-2.09c4.65-4.55,9.26-9.14,13.9-13.71.81-.8,1.44-1.64,1-2.84s-1.41-1.5-2.54-1.66c-6.3-.9-12.6-1.84-18.91-2.72a2.48,2.48,0,0,1-2.13-1.62C83,60.12,80.21,54.38,77.42,48.61A2.63,2.63,0,0,0,75,46.75c-1.32,0-2,.83-2.48,1.91-2.82,5.84-5.69,11.66-8.49,17.52a2.07,2.07,0,0,1-1.76,1.32c-6.31.89-12.6,1.84-18.91,2.72-1.22.17-2.33.4-2.78,1.71s.32,2.11,1.15,2.93l13.9,13.72a1.6,1.6,0,0,1,.66,1.61c-.62,3.3-1.17,6.62-1.74,9.93C54,103.7,53.4,107.28,52.84,110.65Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M55.62,125.28c-2.7,1.25-5.49,2.29-8.29,3.31a154.39,154.39,0,0,1-25.81,6.86c-2.1.37-2.59-.22-1.85-2.21,1.22-3.27,2.47-6.53,3.65-9.81a2.06,2.06,0,0,1,1.91-1.55,72.71,72.71,0,0,0,9.23-1.81,3.23,3.23,0,0,0,2-1,2.31,2.31,0,0,0-2.34-3.69c-3.09.79-6.2,1.4-9.35,1.93a4,4,0,0,1-3.9-1.07c-1.24-1.22-2.66-2.27-4-3.38a1.3,1.3,0,0,1-.61-1.38c.18-.69.72-.83,1.34-.88a175.93,175.93,0,0,0,17.87-2.42c.48-.09.81-.09,1.12.39a46.35,46.35,0,0,0,18.95,16.48S55.57,125.14,55.62,125.28Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M94.21,125.18a46.3,46.3,0,0,0,19.11-16.46,1,1,0,0,1,1.2-.53,175.73,175.73,0,0,0,17.86,2.42c.62.06,1.17.19,1.36.87a1.28,1.28,0,0,1-.6,1.39c-1.69,1.4-3.39,2.8-5.06,4.22a2,2,0,0,1-1.64.36,79.5,79.5,0,0,1-10.16-1.94c-1.65-.41-2.86.19-3.22,1.53s.44,2.47,2.07,2.91a73.46,73.46,0,0,0,9.75,2,2,2,0,0,1,1.79,1.51c1.19,3.28,2.43,6.54,3.65,9.81.74,2,.26,2.6-1.82,2.23A155.26,155.26,0,0,1,105,129.39c-3.34-1.16-6.64-2.41-9.9-3.79C94.85,125.5,94.62,125.38,94.21,125.18Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M77.32,22.58c0,1.7,0,3.41,0,5.11s-.93,2.87-2.35,2.84-2.26-1.07-2.27-2.77q0-5.25,0-10.5c0-1.84.87-2.84,2.34-2.82s2.27,1,2.29,2.89S77.32,20.83,77.32,22.58Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M114,46.69a2.29,2.29,0,0,1-2.11-1.41,2.22,2.22,0,0,1,.56-2.58c2-2,3.92-3.94,5.89-5.9.76-.76,1.49-1.55,2.29-2.27a2.22,2.22,0,0,1,3.15,0,2.19,2.19,0,0,1,.06,3.24c-2.72,2.79-5.5,5.52-8.26,8.27A2.41,2.41,0,0,1,114,46.69Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M38.28,44.4A2.34,2.34,0,0,1,37,46.46a2.06,2.06,0,0,1-2.39-.28c-2.88-2.82-5.74-5.66-8.55-8.56a2.26,2.26,0,0,1,3.15-3.21c2.9,2.79,5.73,5.67,8.57,8.53A2.22,2.22,0,0,1,38.28,44.4Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M50.37,21.49a2.22,2.22,0,0,1,2,1.38c.94,2.22,1.88,4.44,2.74,6.69a2.21,2.21,0,0,1-1.29,2.87A2.18,2.18,0,0,1,51,31.33c-1-2.24-2-4.5-2.85-6.8A2.3,2.3,0,0,1,50.37,21.49Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M15.64,56.46a9.86,9.86,0,0,1,1,.3c1.94.79,3.89,1.59,5.82,2.41C24,59.81,24.52,61,24,62.28a2.36,2.36,0,0,1-3.27,1.17c-2.07-.84-4.14-1.71-6.18-2.61a2.13,2.13,0,0,1-1.26-2.67A2.24,2.24,0,0,1,15.64,56.46Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M136.77,58.8a2.1,2.1,0,0,1-1.3,2c-2.17.94-4.36,1.86-6.57,2.71a2.26,2.26,0,0,1-1.74-4.18c2.16-1,4.34-1.9,6.56-2.73A2.22,2.22,0,0,1,136.77,58.8Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M102,24.1c-.09.29-.2.72-.37,1.13Q100.47,28,99.28,30.8c-.67,1.56-1.88,2.16-3.17,1.61A2.38,2.38,0,0,1,95,29.12c.82-2,1.66-4.06,2.55-6.06a2.19,2.19,0,0,1,2.75-1.32A2.35,2.35,0,0,1,102,24.1Z"
            transform="translate(-6 -14.44)"
         />
         <path
            className="cls-1"
            d="M58.18,106.73c.44-2.69.84-5.19,1.27-7.7.55-3.27,1.11-6.54,1.7-9.8a2.94,2.94,0,0,0-1.06-2.75c-3.62-3.55-7.22-7.13-10.84-10.69-.44-.44-.91-.85-1.63-1.51l7.05-1.06c3.33-.49,6.65-1,10-1.44a3.36,3.36,0,0,0,2.83-2.12c2.2-4.66,4.48-9.27,6.73-13.9l.67-1.3c.51.16.53.61.69.94,2.29,4.67,4.61,9.31,6.8,14a3.9,3.9,0,0,0,3.36,2.44c5.2.69,10.39,1.47,15.58,2.23a7.1,7.1,0,0,1,.71.17c-.11.57-.57.81-.89,1.13q-5.6,5.55-11.21,11.08a3.2,3.2,0,0,0-1,3.13c1,5.29,1.84,10.6,2.74,15.91,0,.35,0,.7.08,1.21l-11.23-6c-1.31-.7-2.64-1.35-3.91-2.09a3.08,3.08,0,0,0-3.29,0c-4.65,2.52-9.32,5-14,7.46C59,106.33,58.69,106.48,58.18,106.73Z"
            transform="translate(-6 -14.44)"
         />
      </svg>
   );
};

export default ExcellenceIcon;
